import './index.scss';

import { Component } from 'react';
import { FormikProps } from 'formik';
import { BraxSelectField, BraxTextField } from 'design-system';

import countries from '../../../../variables/countrys';
import states from '../../../../variables/states';
import typePerson, { TypePerson } from '../../../../variables/type-person';
import masks from '../../../../variables/masks';
import t from '../../../../utils/i18n';
import { CheckoutValue } from '../../../../schemas/plans/checkout';
import ZipCodeField from '../../../../components/ZipCodeField';
import UserAddress from '../../../../view-model/users/UserAddress';

export type CheckoutStepOneFieldsProps = {
    isForeign: boolean,
    typePerson: TypePerson,
    formik: FormikProps<CheckoutValue>
};

type CheckoutStepOneFieldsState = {
    disabled: boolean,
    error: Error | null
};

export default class CheckoutStepOneFields extends Component<CheckoutStepOneFieldsProps, CheckoutStepOneFieldsState> {

    state: CheckoutStepOneFieldsState = {
        disabled: false,
        error: null
    };

    countryOptions = countries.map(country => ({
        value: country,
        title: country,
        icon: 'map'
    }));

    stateOptions = states.map(state => ({
        title: state.name,
        value: state.name
    }));

    typePersonOptions = typePerson.map(option => ({
        ...option,
        icon: option.value === 'natural' ? 'user' : 'office'
    }));

    componentDidUpdate() {
        if (this.state.error?.message === 'not found' && !this.props.formik.errors.payer?.address?.zipCode)
            this.props.formik.setFieldError('payer.address.zipCode', 'CEP não encontrado.');
    }

    setToLoadAddressStarted() {
        this.setState({
            error: null,
            disabled: true
        });
    }

    setToLoadedAddress(address: Partial<UserAddress>) {
        address = {
            state: '',
            stateCode: '',
            city: '',
            district: '',
            address: '',
            number: '' as any,
            complement: '',
            ...address
        };

        let key: keyof typeof address;
        for (key in address)
            this.props.formik.setFieldValue(`payer.address.${key}`, address[key]);

        this.setState({ disabled: false });
    }

    setToLoadAddressFailed(error: Error) {
        if (error?.message === 'not found')
            this.props.formik.setFieldError('payer.address.zipCode', 'CEP não encontrado.');

        this.setState({
            error,
            disabled: false
        });
    }

    render() {
        return (
            <div className="checkout-step-one-field">
                <h3>1. { t('Identificação') }</h3>

                <BraxSelectField
                    label="País"
                    placeholder="País"
                    name="payer.address.country"
                    options={this.countryOptions}
                    disabled={this.state.disabled}
                    variant="label-as-title"
                    onChange={() => this.setToLoadedAddress({ zipCode: '' })}
                />

                { this.props.isForeign ? (<>
                    {/* <BraxTextField
                        type="text"
                        name="payer.foreignId"
                        label={t('ID, NIE, VAT, Passport, ...')}
                        placeholder={t('V565371-S')}
                    /> */}

                    <BraxTextField
                        type="text"
                        name="payer.foreignName"
                        label={t('Nome (estrangeiro)')}
                        placeholder={t('ex. Gabriel dos Santos')}
                    />
                </>) : (<>
                    <BraxSelectField
                        label={t('Tipo de pessoa')}
                        placeholder={t('Tipo de pessoa')}
                        name="payer.typePerson"
                        options={this.typePersonOptions}
                        variant="label-as-title"
                    />

                    { this.props.typePerson === 'natural' ? (<>
                        <BraxTextField
                            type="text"
                            name="payer.cpf"
                            mask={masks.cpf}
                            label="CPF"
                            placeholder={t('123.123.123-12')}
                        />

                        <BraxTextField
                            type="text"
                            name="payer.firstName"
                            label={t('Nome')}
                            placeholder={t('ex. Gabriel')}
                        />

                        <BraxTextField
                            type="text"
                            name="payer.lastName"
                            label={t('Sobrenome')}
                            placeholder={t('ex. dos Santos')}
                        />
                    </>) : (<>
                        <BraxTextField
                            type="text"
                            name="payer.cnpj"
                            mask={masks.cnpj}
                            label="CNPJ"
                            placeholder={t('12.123.123/1234-12')}
                        />

                        <BraxTextField
                            type="text"
                            name="payer.companyName"
                            label={t('Razão social')}
                            placeholder={t('ex. Minha Empresa Negócios Diversos LTDA')}
                        />
                    </>) }

                    <ZipCodeField
                        name="payer.address.zipCode"
                        isForeign={!!this.props.isForeign}
                        onLoadStart={() => this.setToLoadAddressStarted()}
                        onLoaded={address => this.setToLoadedAddress(address)}
                        onLoadFail={error => this.setToLoadAddressFailed(error)}
                    />

                    {/* { this.props.isForeign ? (
                        <BraxTextField
                            type="text"
                            name="payer.address.state"
                            label={t('Estado')}
                            placeholder={t('ex. São Paulo')}
                            disabled={this.state.disabled}
                        />
                    ) : ( */}
                        <BraxSelectField
                            label={t('Estado')}
                            name="payer.address.state"
                            placeholder={t('Estado')}
                            disabled={this.state.disabled}
                            options={this.stateOptions}
                        />
                    {/* ) } */}

                    <BraxTextField
                        type="text"
                        name="payer.address.city"
                        label={t('Município')}
                        placeholder={t('ex. São Paulo')}
                        disabled={this.state.disabled}
                    />

                    <BraxTextField
                        type="text"
                        name="payer.address.district"
                        label={t('Bairro')}
                        placeholder={t('ex. Higienópolis')}
                        disabled={this.state.disabled}
                    />

                    <BraxTextField
                        type="text"
                        name="payer.address.address"
                        label={t('Endereço')}
                        placeholder={t('ex. Av. Paulista')}
                        disabled={this.state.disabled}
                    />

                    <BraxTextField
                        type="text"
                        name="payer.address.number"
                        label={t('Número endereço')}
                        placeholder={t('ex. 1020')}
                    />

                    <BraxTextField
                        type="text"
                        name="payer.address.complement"
                        label={t('Complemento')}
                        placeholder={t('ex. Bloco A, ap. 101')}
                        maxLength={30}
                    />
                </>) }
            </div>
        );
    }

};
